import Link from 'next/link';
import type { ArticuloAyuda } from '@/content/ayuda/articulos';

interface PropsListaArticulosAyuda {
    readonly articulos: readonly ArticuloAyuda[];
}

/** Tarjetas con las guías de uso: cada una lleva a su página estable /ayuda/<slug> (D-27). */
export default function ListaArticulosAyuda({ articulos }: PropsListaArticulosAyuda) {
    return (
        <section data-lista-articulos-ayuda aria-labelledby="guias-de-uso" className="mb-16">
            <h2 id="guias-de-uso" className="text-2xl md:text-3xl font-bold font-display text-ink mb-6">
                Guías de uso
            </h2>
            <ul className="grid gap-4 sm:grid-cols-2">
                {articulos.map((articulo) => (
                    <li key={articulo.slug}>
                        <Link
                            href={`/ayuda/${articulo.slug}`}
                            className="flex h-full min-h-11 flex-col gap-2 bg-surface-2 border-2 border-ink rounded-2xl p-5 shadow-[4px_4px_0px_0px_var(--shadow-color)] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[6px_6px_0px_0px_var(--shadow-color)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent-blue-medium"
                        >
                            <span className="text-lg font-bold font-display text-ink">{articulo.titulo}</span>
                            <span className="text-sm text-ink/70 font-medium leading-relaxed line-clamp-3">{articulo.respuestaCorta}</span>
                        </Link>
                    </li>
                ))}
            </ul>
        </section>
    );
}
